import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=110e0f74&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.vue?vue&type=style&index=0&id=110e0f74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e0f74",
  null
  
)

export default component.exports